const initializedSections = new WeakSet();

const setOfferingState = (item, isOpen) => {
  const trigger = item.querySelector('.search-leaders-sec__trigger');
  const panel = item.querySelector('.search-leaders-sec__panel');

  if (!trigger || !panel) {
    return;
  }

  item.classList.toggle('is-open', isOpen);
  trigger.setAttribute('aria-expanded', String(isOpen));
  panel.setAttribute('aria-hidden', String(!isOpen));
  panel.toggleAttribute('inert', !isOpen);
};

const initSearchLeaders = (scope = document) => {
  const sections = scope.matches?.('.search-leaders-sec')
    ? [scope]
    : scope.querySelectorAll('.search-leaders-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const items = Array.from(section.querySelectorAll('.search-leaders-sec__item')).filter(
      (item) => item.querySelector('.search-leaders-sec__trigger') && item.querySelector('.search-leaders-sec__panel')
    );

    if (!items.length) {
      return;
    }

    initializedSections.add(section);
    section.querySelectorAll('video.js-deferred-video').forEach((video) => {
      const showPhoto = () => {
        if (!Array.from(video.querySelectorAll('source')).some((source) => source.getAttribute('src'))) {
          return;
        }

        video.hidden = true;
        video.pause();
      };

      video.addEventListener('error', showPhoto);
      video.querySelectorAll('source').forEach((source) => source.addEventListener('error', showPhoto));
    });
    items.forEach((item, index) => setOfferingState(item, index === 0));

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('.search-leaders-sec__trigger');

      if (!trigger || !section.contains(trigger)) {
        return;
      }

      const item = trigger.closest('.search-leaders-sec__item');

      if (!item || !items.includes(item)) {
        return;
      }

      const shouldOpen = !item.classList.contains('is-open');
      items.forEach((currentItem) => setOfferingState(currentItem, currentItem === item && shouldOpen));
    });
  });
};

initSearchLeaders();
window.initSearchLeaders = initSearchLeaders;
